import "./App.css";
import { Notice } from "./Notice";

function App() {
  return (
    <div className="App">
      <Notice />
    </div>
  );
}

export default App;
